import { AnalyticsChartInterval } from "@/queries/useRequestAnalytics";

export interface AnalyticsDateRange {
  from: Date;
  to: Date;
}

const DEFAULT_BUCKET_MINUTES = 1;

export const getChartIntervalBucketMinutes = (chartInterval: AnalyticsChartInterval) =>
  chartInterval.bucketMinutes ?? DEFAULT_BUCKET_MINUTES;

export const getChartIntervalBucketSizeMs = (chartInterval: AnalyticsChartInterval) =>
  chartInterval.bucketSizeMs;
